<script setup lang="ts">
import KTooltip from '@/components/tooltips/KTooltip.vue';

export interface Props {
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const model = defineModel<boolean>({ default: false });
</script>

<template>
  <v-checkbox
    v-model="model"
    :disabled="props.disabled"
    :class="$style.saveToAddressBookField"
    density="compact"
    hide-details
    data-testid="saveToAddressBookField"
  >
    <template #label>
      <span :class="$style.saveLabel">
        Add to Address Book
        <KTooltip location="top">
          <template #activator="{ props: tooltipProps }">
            <v-icon
              v-bind="tooltipProps"
              icon="mdi-information-outline"
              size="14"
              :class="$style.infoIcon"
            />
          </template>
          <span>
            If you check this option, the data in all previous fields will be
            saved in the address book. This address will show up in future
            bookings.
          </span>
        </KTooltip>
      </span>
    </template>
  </v-checkbox>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.saveToAddressBookField {
}

.saveLabel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8125rem;
  color: colors.$color-text-primary;
}
.infoIcon {
  color: colors.$color-text-secondary;
  cursor: help;
}
</style>
